import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CurrentSkedTask} from 'src/app/core/model/task';
import {getTaskPercentComplete} from 'src/app/current-sked/shared/utils/get-task-percent-complete';
import {getPriorityText} from '../get-priority-text';

@Component({
  selector: 'current-sked-task-progress',
  templateUrl: './current-sked-task-progress.component.html',
  styleUrls: ['./current-sked-task-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedTaskProgressComponent implements OnChanges {
  @Input() task: CurrentSkedTask;
  @Input() strokeWidth = 12;
  @Input() diameter = 67;

  percentComplete: number;
  priorityText: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.task && this.task) {
      this.percentComplete = getTaskPercentComplete(this.task).percent;
      this.priorityText = getPriorityText(this.task.priority);
    }
  }
}
